"use client";
import React from "react";
import Icon from "@/components/icons/Icons";
import Link from "next/link";
import { formatDate } from "@/utils/commonFunctions";
import { useIsMobile } from "@/utils/useIsMobile";
import { useLoginModal } from "@/utils/useLoginModal";
import { RollingFilledNavData } from "@/type/rollingPageTypes";
import { ReturnData, SchemeReturn } from "@/type/schemeType";
import SectionHeading from "../others/SectionHeading";
import InformationButton from "@/components/ui/InformationButton";
import DummyRollingSection from "./DummyRollingSection";
import RollingTableAndChart from "../others/RollingTableAndChart";

export default function RollingReturnSection({
  returnData,
  rollingData,
  msoId,
  rollingNavData,
  isLoggedInServer,
}: {
  returnData: SchemeReturn;
  rollingData: ReturnData;
  msoId: number;
  rollingNavData: RollingFilledNavData[][];
  isLoggedInServer?: boolean;
}) {
  const isMobile = useIsMobile();

  const { isLoggedIn } = useLoginModal();

  const showRealContent = isLoggedIn || isLoggedInServer;

  return (
    <section className="mb-8 xs:mb-12">
      <div className="flex items-center gap-3 mb-2 sm:mb-4">
        <SectionHeading heading="Rolling Returns" />
        <InformationButton keywords="rolling-return" />

        {!isMobile && (
          <Link
            href={`/tools-and-calculators/rolling-returns?catid=${rollingData.category_id}&msoid=mso${msoId}`}
            className="hidden sm:flex items-center gap-2 border border-primaryBlue rounded-lg justify-center text-2xs font-semibold text-primaryBlue leading-4 py-2 px-4 ml-auto transition duration-350 sm:hover:bg-primaryBlue sm:hover:text-white"
          >
            View full Rolling Returns
            <Icon.rightArrow />
          </Link>
        )}
        {isMobile && rollingData.updated_at && (
          <p className="text-xs text-[#6E6E73] font-medium ml-auto">As of {formatDate(rollingData.updated_at)}</p>
        )}
      </div>

      <div className="bg-white border border-[#E9E9EB] p-6 rounded-4xl relative overflow-hidden">
        {showRealContent ? (
          <RollingTableAndChart returnData={returnData} rollingData={rollingData} rollingNavData={rollingNavData} />
        ) : (
          <DummyRollingSection returnData={returnData} />
        )}
      </div>

      {isMobile && (
        <Link
          href={`/tools-and-calculators/rolling-returns?catid=${rollingData.category_id}&msoid=mso${msoId}`}
          className="flex sm:hidden items-center gap-2 border border-primaryBlue rounded-xl justify-center text-2xs font-semibold text-primaryBlue leading-4 py-2 px-4 mt-5"
        >
          View full Rolling Returns
          <Icon.rightArrow />
        </Link>
      )}

      {!isMobile && rollingData.updated_at && (
        <p className="text-xs text-[#6E6E73] font-medium mt-2.5">As of {formatDate(rollingData.updated_at)}</p>
      )}
    </section>
  );
}
